var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 26c-.491 0-.981-.12-1.427-.361l-18.5-10 2.854-5.278L24 19.59l17.073-9.229 2.854 5.278-18.5 10A2.997 2.997 0 0124 26z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16v22H9a3 3 0 01-3-3V16h4zM38 16v22h1a3 3 0 003-3V16h-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M37.5 38.5h-27a5 5 0 01-5-5v-19a5 5 0 015-5h27a5 5 0 015 5v19a5 5 0 01-5 5z"
  })));
}

export default SvgGmail;